import { memo, useMemo } from "react";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	roomNum: number;
};

export const RoomNumOfBasicInfoCompositions = memo(({ roomNum }: Props) => {
	const roomNumText = useMemo(() => {
		return `${roomNum} 部屋`;
	}, [roomNum]);

	return <BasicInfoLabelWithTextLayout label="合計部屋数" textChildren={<p>{roomNumText}</p>} />;
});
